export default "__VITE_ASSET__Dgu4ckhs__"